<template>
  <div class="commonFoot">
    <div class="container"> 
        <div class="links"> 
             <router-link :to="{path:'/HelpCenter/CopyRight'}">用户指南</router-link>
              |
             <router-link :to="{path:'/FunctionDescription'}">功能说明</router-link>
              |
             <router-link :to="{path:'/LawService'}">法律服务</router-link>
              |
            <router-link :to="{path:'/ContactUs'}">联系我们</router-link>
        </div>
        <div class="copyRight"> 
          <!-- ©2022 中国知链 版权所有 保留一切权利 -->
        </div>
        <!-- <a href="https://beian.miit.gov.cn/" target="_blank" class="text-light-gray">ICP备案：鄂ICP备2021022303号-2</a>  -->

        <div class="foot">
          <p><a href="https://beian.miit.gov.cn/" target="_blank">ICP备案：鄂ICP备2021022303号-2</a><img src="../../assets/images/footIcon.png" /><a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42011102005993" rel="noreferrer" target="_blank">鄂公网安备42011102005993号</a ></p>
          <p>国家互联网信息办公室区块链信息服务备案编号：<a href="https://bcbeian.ifcert.cn/" target="_blank">42011122891907500013</a></p>
          <p>Copyright © 2026 中国知链 All rights reserved.</p>
        </div>
     </div>
  </div>
</template>

<script>
export default {
  name: 'FootBlock',

  data () {
    return {
    }
  },

  methods: {}
}
</script>

<style lang='scss'>
    .commonFoot{
        background:#04397F;
        text-align: center;
        padding:32px 0 24px;
        .links{
           color:rgba(255,255,255,.2);
            a{
                color:rgba(255,255,255,.85);
                margin:0 8px;
                text-decoration: none;
            }
            a:hover{
              color:rgba(255,255,255,1);
            }
        }
        .copyRight{
          color:rgba(255,255,255,.45);
          border-top:solid 1px rgba(255,255,255,.1);
          padding-top:24px;
          margin-top:24px;
        }
        .text-light-gray{
          color:rgba(255,255,255,.45);
        }
    }
    .foot{
        width: 100%;
        text-align: center;
        // padding:20px 0;
        .links{
           color:#999;
            a{
                color:#999;
                margin:0 8px;
                text-decoration: none;
                opacity: 0.9;
            }
            a:hover{
              opacity: 1;
            }
        }
        .copyRight{
          color:#999;
          border-top:solid 1px rgba(0,0,0,0.1);
          padding-top:24px;
          margin-top:24px;
        }
        .text-light-gray{
          color:rgba(255,255,255,.45);
        }
        p{
          display: flex;
          justify-content: center;
          align-items: center;
          // color: #8F8F8F;
          color:rgba(255,255,255,.45);
          a{
            // color: #8F8F8F;
            color:rgba(255,255,255,.45);
            text-decoration: none;
          }
          img{
            width: 15px;
            height: 15px;
            margin: 0 5px 0 10px;
          }
        }
    }

    // 适配移动端
@media screen and (max-width: 991px){
  .foot p{display: block;}
}
</style>
